import useUpdateCodeField from './useUpdateCodeField';

/**
 * Hook to handle code updates from ActionCable
 * @returns {Function} Function to handle code updates from cable
 */
export function useUpdateCodeFromCable() {
  // Get the mutation function from useUpdateCodeField
  const updateCodeMutation = useUpdateCodeField(
    // We don't need an API function since we're not calling the API
    // We'll just pass the data directly to React Query cache
    // The cable already has the data from the server
    ({ codeId, ...updates }) => Promise.resolve({ ...updates, id: codeId }),
    'Error updating code from cable'
  );
  
  /**
   * Handle code updates from cable
   * @param {Object} codeData - The code data received from cable
   */
  const updateCodeFromCable = (codeData) => {
    if (!codeData || !codeData.id) {
      console.error('Invalid code data received from cable', codeData);
      return;
    }
    
    // Use the mutation from useUpdateCodeField
    // Convert the data to the format expected by the mutation
    updateCodeMutation.mutate({ 
      codeId: codeData.id,
      ...codeData
    });
  };
  
  return updateCodeFromCable;
}
